import axios from 'axios';
let BASE_URL: string;
let BASE_APP_URL: string;
let PHP_APP_URL = process.env.REACT_APP_PHP_APP_URL;

if (window.location.hostname.includes('localhost')) {
    BASE_URL = 'https://localhost:7269';
    BASE_APP_URL = 'http://localhost:3000';
    PHP_APP_URL = 'https://52.15.139.18';
} else if (window.location.hostname.includes('dev')) {
    //BASE_URL = 'https://venturerespiratorydev.azurewebsites.net';
    BASE_URL = 'https://api.devapp.ventureresp.com'; 
    BASE_APP_URL = 'https://devapp.ventureresp.com';
    PHP_APP_URL = 'https://52.15.139.18';
} else {
    //BASE_URL = 'https://venturerespiratory.azurewebsites.net';
    BASE_URL = 'https://api.app.ventureresp.com';      
    BASE_APP_URL = 'https://app.ventureresp.com';
    PHP_APP_URL = 'https://tracking.ventureresp.com';
}

const api = axios.create({
    baseURL: BASE_URL,
    withCredentials: true,
});

export { BASE_URL, BASE_APP_URL, PHP_APP_URL, api };